<template>
  <div v-if="dimension" class="step__body">
    <h3>{{ step.title ? step.title : step.name }}</h3>
    <p>{{ step.description }}</p>
    <div class="row option">
      <DimensionOption :option="step.width" :option-dim="dimension.width" type="width"/>
      <DimensionOption :option="step.height" :option-dim="dimension.height" :height-max="heightMax" type="height"/>
    </div>
    <div class="row">
      <div class="col-md-12">
        <br>
        <div class="alert alert-info" v-if="dimensionCapsText">{{ dimensionCapsText }}</div>
        <div class="badge text-danger" v-if="name === 'Schiebetore'">Ausleger: {{ ausleger }}cm
        </div><tooltip :tooltip="tooltip" style="display:inline-block" v-if="name === 'Schiebetore'"><span class="fa fa-info-circle"></span></tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref } from '@vue/reactivity'
import { watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
import DimensionOption from './dimensionOption'
import { clampDimensionValue, computeHeightMaxFromSpecialDim, heightLimitOption } from '~/lib/dimensionLimits'

export default {
  name: 'Dimension',
  components: {
    DimensionOption
  },
  setup () {
    const tooltip = ref({
      text: 'Der Ausleger dient als Gegengewicht für das Schiebetor und ermöglicht damit die freitragende Konstruktion. Der Ausleger ist das hintere Dreieck bei dem Schiebetor, dessen Länge sich nach der Torbreite variiert.<br/> Als Beispiel: Ein Schiebetor hat eine Einfahrtsbreite von 3,5m, der Ausleger hat bei der Torbreite 1,5m, das gesamte Schiebetor ist somit 5m breit. D.h. das Schiebetor braucht 5m Platz um komplett rauszufahren. Es ist wichtig diese Angaben bei der Planung zu berücksichtigen.<br/> Den Ausleger kann man als Sonderkonstruktion 20cm kürzer machen, einfach Anfragen.',
      image: 'https://www.loewe-zaun.de/wp-content/uploads/2024/04/ausleger.jpg',
      type: 'blind'
    })

    const store = useStore()
    const step = computed(() => {
      return store.getters['configurator/currentStep']
    })
    const dimensionCapsText = computed(() => {
      return store.getters['configurator/dimensionCapsText']
    })
    const name = computed(() => {
      return store.getters['configurator/name']
    })
    const ausleger = computed(() => {
      return store.getters['configurator/ausleger']
    })
    const modelOptions = computed(() => {
      const steps = store.getters['configurator/steps'] || []
      const modelStep = steps.find(s => s.model_step)
      return modelStep?.options || []
    })
    const selectedModelOption = computed(() => {
      return modelOptions.value.find(o => o.selected) || null
    })
    const heightSource = computed(() => {
      return heightLimitOption(modelOptions.value, selectedModelOption.value)
    })
    const dimension = computed(() => {
      const option = selectedModelOption.value
      if (!option?.dimension) {
        return null
      }
      const source = heightSource.value
      if (!source?.dimension?.height || source === option) {
        return option.dimension
      }
      return {
        ...option.dimension,
        height: {
          ...source.dimension.height,
          value: option.dimension.height?.value
        }
      }
    })
    const heightMax = computed(() => {
      const option = selectedModelOption.value
      const source = heightSource.value
      if (!option || !source) {
        return 0
      }
      const width = option.dimension?.width?.value ?? step.value?.width?.value
      return computeHeightMaxFromSpecialDim(source.special_dim, width)
    })

    watch([heightMax, dimension], ([maxHeight, dim]) => {
      if (!dim?.height || !(maxHeight > 0)) {
        return
      }
      const current = Number.parseInt(dim.height.value, 10)
      if (current > maxHeight) {
        const next = clampDimensionValue(current, dim.height.min, maxHeight, dim.height.step)
        if (next !== current) {
          store.dispatch('configurator/setDimension', {
            type: 'height',
            value: next
          })
        }
      }
    })

    return {
      step,
      dimension,
      heightMax,
      tooltip,
      dimensionCapsText,
      name,
      ausleger
    }
  }
}
</script>
